// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    GetPatientRequestModel,
    HubSearchAccountsRequestModel,
    HubV1GetAccountGetAccountRequestModel,
    HubV1HubV1GetAccountDefaultResponse,
    HubV1HubV1GetPatientDefaultResponse,
    HubV1HubV1SavePatientDefaultResponse,
    HubV1HubV1SearchAccountsDefaultResponse,
    HubV1HubV1SearchPatientsDefaultResponse,
    SavePatientRequestModel,
    SearchPatientsRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeHubApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param hubV1GetAccountGetAccountRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubV1GetAccount (hubV1GetAccountGetAccountRequestModel: HubV1GetAccountGetAccountRequestModel, xProgramId?: string): Promise<AxiosResponse<HubV1HubV1GetAccountDefaultResponse>> {
        const _url_ = '/edge/hub/v1/GetAccount';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'hubV1GetAccountGetAccountRequestModel' is not null or undefined
        if (hubV1GetAccountGetAccountRequestModel === null || hubV1GetAccountGetAccountRequestModel === undefined) {
            throw new Error('Required parameter hubV1GetAccountGetAccountRequestModel was null or undefined when calling hubV1GetAccount.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(hubV1GetAccountGetAccountRequestModel, "HubV1GetAccountGetAccountRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<HubV1HubV1GetAccountDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1HubV1GetAccountDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param getPatientRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubV1GetPatient (getPatientRequestModel: GetPatientRequestModel, xProgramId?: string): Promise<AxiosResponse<HubV1HubV1GetPatientDefaultResponse>> {
        const _url_ = '/edge/hub/v1/GetPatient';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'getPatientRequestModel' is not null or undefined
        if (getPatientRequestModel === null || getPatientRequestModel === undefined) {
            throw new Error('Required parameter getPatientRequestModel was null or undefined when calling hubV1GetPatient.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getPatientRequestModel, "GetPatientRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<HubV1HubV1GetPatientDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1HubV1GetPatientDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param savePatientRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubV1SavePatient (savePatientRequestModel: SavePatientRequestModel, xProgramId?: string): Promise<AxiosResponse<HubV1HubV1SavePatientDefaultResponse>> {
        const _url_ = '/edge/hub/v1/SavePatient';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'savePatientRequestModel' is not null or undefined
        if (savePatientRequestModel === null || savePatientRequestModel === undefined) {
            throw new Error('Required parameter savePatientRequestModel was null or undefined when calling hubV1SavePatient.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(savePatientRequestModel, "SavePatientRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<HubV1HubV1SavePatientDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1HubV1SavePatientDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param hubSearchAccountsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubV1SearchAccounts (hubSearchAccountsRequestModel: HubSearchAccountsRequestModel, xProgramId?: string): Promise<AxiosResponse<HubV1HubV1SearchAccountsDefaultResponse>> {
        const _url_ = '/edge/hub/v1/SearchAccounts';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'hubSearchAccountsRequestModel' is not null or undefined
        if (hubSearchAccountsRequestModel === null || hubSearchAccountsRequestModel === undefined) {
            throw new Error('Required parameter hubSearchAccountsRequestModel was null or undefined when calling hubV1SearchAccounts.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(hubSearchAccountsRequestModel, "HubSearchAccountsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<HubV1HubV1SearchAccountsDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1HubV1SearchAccountsDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param searchPatientsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubV1SearchPatients (searchPatientsRequestModel: SearchPatientsRequestModel, xProgramId?: string): Promise<AxiosResponse<HubV1HubV1SearchPatientsDefaultResponse>> {
        const _url_ = '/edge/hub/v1/SearchPatients';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'searchPatientsRequestModel' is not null or undefined
        if (searchPatientsRequestModel === null || searchPatientsRequestModel === undefined) {
            throw new Error('Required parameter searchPatientsRequestModel was null or undefined when calling hubV1SearchPatients.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(searchPatientsRequestModel, "SearchPatientsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<HubV1HubV1SearchPatientsDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HubV1HubV1SearchPatientsDefaultResponse");
        }
        return response;
    }
}
